module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/ko/3/2-e968d7fe974b545ab7118ea4190d3698.jpg";